/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import axios from 'axios';
import React, { useEffect, useMemo } from 'react';

/**
 * Please note this component will wrap all routes exposed through module
 * federation.
 */
function RemoteModuleProvider({ children }) {
  const oktaAuth = useMemo(() => {
    return new OktaAuth({
      issuer: window.REACT_APP_ISSUER,
      clientId: window.REACT_APP_CLIENT_ID,
      redirectUri: window.REACT_APP_REDIRECT_URI,
      postLogoutRedirectUri: window.REACT_APP_LOGOUT_URI,
      scopes: ['openid', 'profile', 'email', 'offline_access', 'pepappdtvtporoles'],
      pkce: true
    });
  }, []);

  const accessToken = JSON.parse(window.localStorage.getItem('okta-token-storage'))?.accessToken
    ?.accessToken;

  useEffect(() => {
    // If already logged in then set access token to axios
    // get the authentication token from local storage if it exists
    if (accessToken) {
      // Set the Authorization header for Axios
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }
  }, [accessToken]);

  const triggerLogin = () => {
    oktaAuth.signInWithRedirect({ originalUri: '/home' });
  };

  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    window.location.replace(toRelativeUrl('/home', window.location.origin));
  };

  const customAuthHandler = () => {
    const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();

    if (!previousAuthState || !previousAuthState.isAuthenticated) {
      triggerLogin();
    }
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={customAuthHandler}
      restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
}

export default RemoteModuleProvider;
